import { render } from "./edit.vue?vue&type=template&id=cc389af2"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/price_bundles/edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cc389af2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cc389af2', __exports__)) {
    console.log('reload')
    api.reload('cc389af2', __exports__)
  }
  
  module.hot.accept("./edit.vue?vue&type=template&id=cc389af2", () => {
    console.log('re-render')
    api.rerender('cc389af2', render)
  })

}


export default __exports__